import { type CommandProperties, createCommand } from '@atlassian/rovo-content-bridge-api';

import type { ConfluenceAccumulatedDataType } from './confluence-accumulated-data-type';

/**
 * Data payload for creating a Confluence page.
 */
export type ConfluenceCreatePageData = ConfluenceAccumulatedDataType & {
	/**
	 * The title to be included in the created page.
	 */
	title: string;
	/**
	 * The adf to be included in the created page.
	 */
	adf: string;
};

/**
 * Properties for the Confluence page creation command.
 *
 * @extends CommandProperties
 */
export interface ConfluenceCreatePageCommandProperties extends CommandProperties {
	/**
	 * The unique key identifier for the page creation request.
	 */
	key: string;
	/**
	 * The data payload containing the content for the new page.
	 */
	data: ConfluenceCreatePageData;
	/**
	 * Whether the stream is complete.
	 */
	isStreamComplete: boolean;
	/**
	 * Trace id of the request
	 */
	traceId?: string;
	/**
	 * Request id for E2E event tracking and request correlation
	 */
	requestId?: string;
}
/**
 * A command sent by a bridge API client to create a new Confluence page.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to create a Confluence page with the specified content.
 */
export const ConfluencePageCreateCommand = createCommand<ConfluenceCreatePageCommandProperties>(
	'confluence-page-create-command',
);
